import {BaseContainerModel} from '../base-container.model';
import {bl_webhook_activity_event_RowClass} from '../../dbschema/bl_webhook_activity_event.model';

export class WebhookActivityEventContainerModel extends BaseContainerModel {
  bl_webhook_activity_event: bl_webhook_activity_event_RowClass = new bl_webhook_activity_event_RowClass();
}
